import { RENT_TRACKING_INVALIDATION_DOMAIN } from '@rentguru/commons-utils';
import { useQueryClient } from '@tanstack/react-query';
import { onSubscriptionsReconnected } from '@up2rent/graphql';
import { useEffect } from 'react';

import { useInvalidationBus } from 'src/hooks/useInvalidationBus';
import { useUser } from 'src/hooks/UserContext';

import { type InvalidationCoalescer } from './rentMatrixWindowUtils';
import { invalidateRentTracking } from './rentTrackingQueries';

interface RentTrackingInvalidationListenerProps {
  coalescer: InvalidationCoalescer;
}

const RentTrackingInvalidationListener = ({ coalescer }: RentTrackingInvalidationListenerProps) => {
  const queryClient = useQueryClient();
  const { clientId } = useUser();

  useInvalidationBus((message) => {
    if (message.domains.includes(RENT_TRACKING_INVALIDATION_DOMAIN)) {
      coalescer.push(message.entityIds);
    }
  });

  useEffect(
    () =>
      onSubscriptionsReconnected(() => {
        coalescer.cancel();
        invalidateRentTracking(queryClient, clientId);
      }),
    [clientId, coalescer, queryClient]
  );

  return null;
};

export default RentTrackingInvalidationListener;
